import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState
} from './sms-template.action';
import { SmsTemplate } from './sms-template.model';

export interface SmsTemplateRecordsState {
    listData: SmsTemplate[];
    singleData: SmsTemplate;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: SmsTemplateRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const SmsTemplateRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);